import { Cancel, Check, CheckCircle, CheckCircleOutline, Delete, DeleteOutlineOutlined, DoNotDisturbAltOutlined, InfoOutlined } from "@mui/icons-material";
import { Avatar, Card, Checkbox, Grid, IconButton, ListItem, ListItemButton, Paper, Popover, Stack, Typography } from "@mui/material";
import moment from "moment";
import { useState } from "react";

const UbicacionCard = ({ turno, horario, duracion, empresa, usuario, usuarioAsignado, sala, mesa, sector, puesto, oficina, asistencia, checked, onAsistencia, onCheck, cancelable, hayCancelables }) => {

  const [popoverOpen, setPopoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const textoDeTurno = (turno) => {
    switch (turno) {
      case 'AFTERNOON':
        return 'TARDE';
        break;
      case 'MORNING':
        return 'MAÑANA';
        break;
      case 'DOBLE':
        return 'DOBLE';
        break;
      default:
        return 'N/A';
        break;
    }
  }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.target);
    setPopoverOpen(true);
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setPopoverOpen(false);
  }

  return <ListItem sx={{ paddingInlineStart: 0 }}
    // onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose}
  >
    <Card variant="elevation" sx={{ width: '100%', padding: '10px', bgcolor: 'rgb(234, 230, 230)' }}>
      <Grid container spacing={1} >
        <Grid item sm={1} alignItems="center" justifyContent="center" display="flex" sx={{pointerEvents: 'none'}}>
          <Avatar src={(usuarioAsignado?.imagen ?? empresa?.imagen) ?? usuario?.imagen}></Avatar>
        </Grid>
        <Grid item container sm={10} spacing={1} sx={{pointerEvents: 'none'}}>
          {/* <Grid item container sm={12} spacing={2}> */}
            {!!sala && <>
              <Grid item alignItems="center" display="flex" sm={8}><Typography color="rgb(50, 150, 50)">{sala}</Typography></Grid>
              <Grid item alignItems="center" display="flex" sm={2}><Typography color="rgb(0, 0, 0)">{moment(horario).format('LT')}</Typography></Grid>
              <Grid item alignItems="center" display="flex" sm={2}><Typography color="rgb(0, 0, 0)">{duracion + 'hs'}</Typography></Grid>
              {!!usuarioAsignado
              ? <Grid item sm={12} sx={{ pointerEvents: 'none' }}><Typography color="blue">{'Asignado: ' + usuarioAsignado.descripcion}</Typography></Grid>
              : <Grid item sm={12} sx={{ pointerEvents: 'none' }}><Typography color="blue">{'Asignado: ' + usuario.descripcion}</Typography></Grid>}
            </>}
            {!!mesa && <>
              <Grid item sm={2}><Typography color="rgb(150, 50, 50)">{'P' + puesto}</Typography></Grid>
              <Grid item sm={6}><Typography color="rgb(0, 0, 0)">{mesa + ' - ' + sector}</Typography></Grid>
              <Grid item sm={4}><Typography color="rgb(0,0,0)">{'Turno: ' + textoDeTurno(turno)}</Typography></Grid>
            </>}
          {/* </Grid> */}
          {!!mesa && !!empresa && <Grid item sm={12} sx={{pointerEvents: 'none'}}>
            {!!usuarioAsignado
              ? <Typography color="blue">{'Asignado: ' + usuarioAsignado.descripcion}</Typography>
              : <Typography color="blue">{'Sin asignar'}</Typography>
            }
          </Grid>}
        </Grid>
        {<Grid item sm={1} alignItems="center" justifyContent="center" display="flex"><IconButton disabled={!onAsistencia} onClick={onAsistencia} >
          {!asistencia ? <Cancel sx={{ color: "red" }} /> : <CheckCircle sx={{ color: "green" }} />}
        </IconButton>
          {!!hayCancelables && <Checkbox disabled={!cancelable} checked={checked} onChange={onCheck} />}
          </Grid>}
      </Grid>
    </Card>
    <Popover
      open={popoverOpen}
      anchorEl={anchorEl}
      sx={{
          pointerEvents: 'none',
        }}
      disableRestoreFocus
      onClose={handlePopoverClose}
      anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'right',
      }}
    >
      <Paper sx={{padding: '10px'}}>
        <Grid container spacing={2}>
          <Grid item sm={12}>
            <Typography>{'Reservado por ' + usuario.descripcion }</Typography>
          </Grid>
          {!!empresa && <Grid item sm={12}>
            <Typography>{'Empresa: ' + empresa.nombre}</Typography>
          </Grid>}
          {!!sala && <Grid item sm={4}>
            <Typography>Reserva de Espacio Privado</Typography>
          </Grid>}
        </Grid>
      </Paper>
    </Popover>
  </ListItem>
}

export default UbicacionCard;